<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          true
          :link="{
            name: $t('COMMON.DASHBOARD'),
            icon: 'ni ni-shop text-primary',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="
            $currentUserCan($permissions.PERM_VIEW_MODULE_ESTABLISHMENT_INTERNAL_ORDERS) &&
            $currentUserManagesProductionCafeteria()
          "
          true
          :link="{
            name: $t('ESTABLISHMENT_INTERNAL_ORDERS.PRODUCTIONS_TO_MAKE'),
            icon: 'fa fa-utensils text-primary',
            path: '/productions',
          }"
        >
        </sidebar-item>
        <!--
          <sidebar-item
            v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SUPPLY_RULES)"
            true
            :link="{
              name: $t('COMMON.SUPPLY_RULES'),
              icon: 'fas fa-truck-moving',
              path: '/supply-rule',
            }"
          >
          </sidebar-item>
        -->
        <sidebar-item
          true
          :link="{
            name: $t('COMMON.ESTABLISHMENTS_DIRECTORY'),
            icon: 'ni ni-books text-primary',
            path: '/establishments-directory',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_EVENTS)"
          true
          :link="{
            name: $t('COMMON.EVENTS'),
            icon: 'fa fa-calendar-alt text-primary',
            path: '/events',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_REPORTS)"
          true
          :link="{
            name: $t('COMMON.REPORTS'),
            icon: 'fa fa-chart-area text-primary',
          }"
        >
          <sidebar-item
            v-if="
              $currentUserCan(
                $permissions.PERM_VIEW_REPORTS_CASH_REGISTER_READINGS
              )
            "
            true
            :link="{
              name: $t('COMMON.CASH_REGISTER_READINGS'),
              path: '/reports/cashregister-readings',
            }"
          >
          </sidebar-item>
          <!--
          Onglet « Caisses » (tableau Grafana « Mes caisses ») masqué à la demande du client.
          <sidebar-item
            v-if="
              $currentUserCan($permissions.PERM_VIEW_REPORTS_CASH_REGISTERS)
            "
            true
            :link="{
              name: $t('COMMON.CASH_REGISTERS'),
              path: '/reports/cashregisters',
            }"
          >
          </sidebar-item>
          -->
          <sidebar-item
            v-if="
              $currentUserCan($permissions.PERM_VIEW_REPORTS_PRODUCTS)
            "
            true
            :link="{
              name: $t('COMMON.PRODUCTS_REPORT'),
              path: '/reports/products',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="
              $currentUserCan($permissions.PERM_VIEW_REPORTS_POS_PRODUCTS)
            "
            true
            :link="{
              name: $t('COMMON.POS_PRODUCTS_REPORT'),
              path: '/reports/pos-products',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="
              $currentUserCan($permissions.PERM_VIEW_REPORTS_WEEKLY_REPORTS) &&
              $currentUserDoesWeeklyReports()
            "
            true
            :link="{
              name: $t('COMMON.WEEKLY_REPORTS_REPORT'),
              path: '/reports/weekly-reports',
            }"
          >
          </sidebar-item>
        </sidebar-item>
        <hr
          class="my-3"
          style="
            border-color: rgba(0, 0, 0, 0.1) currentcolor currentcolor;
            border-style: solid none none;
            border-width: 1px 0px 0px;
            border-image: none 100% / 1 / 0 stretch;
            min-width: 80%;
            overflow: visible;
            box-sizing: content-box;
            height: 0px;
          "
        />

        <lang-switcher />
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import moduleLayoutMixin from "@/mixins/module-layout-mixin";
import { LangSwitcher } from "@/components";
import DashboardNavbar from "../../Layouts/Authenticated/DashboardNavbar.vue";
import ContentFooter from "../../Layouts/Authenticated/ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
    LangSwitcher,
  },
  mixins: [moduleLayoutMixin],

  data() {
    return {};
  },

  methods: {},

  async mounted() {},

  computed: {},

  watch: {},
};
</script>
